import { inject, Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { I18nService } from '../i18n';

@Pipe({ 
    name: 'sqlDate',
    standalone: true
})
export class TransformSQLDatePipe implements PipeTransform {
	transform(val: string) {
    if (!val) return null;
    return moment.utc( val.replace('T', ' '), 'YYYY-MM-DD HH:mm:ss').local().toDate(); 
	}
}

@Pipe({ 
    name: 'calendarDay',
    standalone: true
})
export class CalendarDayPipe implements PipeTransform {
	transform(val: string | Date) {
    if (!val) return '';
	  return moment.utc(val).local().calendar(null,{
            lastDay : '[Yesterday]',
            sameDay : 'LT',
            nextDay : '[Tomorrow]',
            lastWeek : 'dddd',
            nextWeek : 'dddd', /* not really, everything is from the past */
            sameElse : 'L'
        }); 
	}
}

@Pipe({ 
    name: 'sessionDay',
    standalone: true
})
export class SessionDayPipe implements PipeTransform {
	transform(val: string | Date) {
    if (!val) return '';

	  return moment.utc(val).local().calendar(null,{
            lastDay : '[Yesterday] LT',
            sameDay : '[Today] LT',
            nextDay : '[Tomorrow] LT',
            lastWeek : 'dddd LT',
            nextWeek : 'dddd LT', /* not really, everything is from the past */
            sameElse : 'L LT'
        }); 
	}
}

@Pipe({ 
    name: 'loginDate',
    standalone: true
})
export class LoginDatePipe implements PipeTransform {
	private i18n = inject(I18nService);

	transform(val: string) {
        if (!val) return this.i18n.t('core.pipes.dates_pipe.no_logins_yet', 'No Logins Yet');
	    return moment.utc( val.replace('T', ' '), 'YYYY-MM-DD HH:mm:ss').local().toDate().toDateString(); 
        
    }
}

@Pipe({ 
    name: 'createdDate',
    standalone: true
})
export class CreatedDatePipe implements PipeTransform {
	transform(val: string) {
        if (!val) return "";
	    return moment.utc( val.replace('T', ' '), 'YYYY-MM-DD HH:mm:ss').local().format("MMMM Do YYYY");
    }
}

@Pipe({ name: 'amDateFormat', standalone: true })
export class DateFormatPipe implements PipeTransform {
  transform(value: moment.MomentInput, ...args: any[]): string {
    if (!value) {
      return '';
    }
    return moment(value).format(args[0]);
  }
}


@Pipe({ name: 'amFromUtc', standalone: true })
export class FromUtcPipe implements PipeTransform {
  transform(value: moment.MomentInput, formats?: string | string[], ...args: string[]): any {
    return formats ? moment.utc(value, formats) : moment.utc(value);
  }
}

@Pipe({ name: 'amLocal', standalone: true })
export class LocalTimePipe implements PipeTransform {
  transform(value: moment.MomentInput): moment.Moment {
    return moment(value).local();
  }
}